import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IndexApp from "../../Components/IndexApp";
import { getActiveBrandConfig } from "../../config/environment.config";
import { isTeachrAccountActive } from "../../Utils/Function";
import { DV2 } from "../../App/DeclarationV2/theme";
import DraftsList from "../../App/BrouillonsV2/DraftsList";

/**
 * Brouillons v2, route `/{marque}/tableau-de-bord/{prestation}/brouillons`
 * (maquettes 1g et 2g du 29 octobre 2026). L'onglet « Brouillons » de
 * l'écran « Mes cours » n'est pas modifié.
 */
const BrouillonsV2Page = () => {
    const navigate = useNavigate();
    const teachr = useSelector((s: any) => s.user.currentUser.teachr);

    // Garde : un prof dont le compte n'est pas actif ne déclare pas (le serveur refuse aussi).
    useEffect(() => {
        if (teachr?.id && !isTeachrAccountActive(teachr)) {
            navigate(`/${getActiveBrandConfig()}/profile/complete`, { replace: true });
        }
    }, [teachr, navigate]);

    return (
        <IndexApp
            navBar={{ index: 1 }}
            teachr={teachr}
            component={
                <main style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)" }}>
                    {teachr?.id ? <DraftsList teachr={teachr} /> : null}
                </main>
            }
        />
    );
};

export default BrouillonsV2Page;
